import { decode as base64_decode, encode as base64_encode } from "base-64";
import RootStore from "./RootStore";
import { postApi } from "../components/Utility";

import config from "../config";
import { action, makeObservable, observable } from "mobx";

class UsageGraphStore {
  usageGraph = [];
  total = 0;
  loading = false;
  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      usageGraph: observable,
      total: observable,
      loading: observable,
      loadUsageGraphData: action,
    });
    this.rootStore = rootStore;
  }

  async loadUsageGraphData({
    offset,
    limit,
    companyId,
    vehicleId,
    distance,
    fromDate,
    toDate,
  }) {
    this.loading = true;
    var postData = {
      companyId: companyId,
      vehicleId: vehicleId,
      fromDate: fromDate,
      toDate: toDate,
      offset: 0,
      limit: 15,
      page: 1,
    };

    if (config.pythonReport === 1) {
      // postData.companyId=10166
      // postData.vehicleId=[27043]
      var response = await postApi
        .getClient("report")
        .post("/graph/usageGraph", postData);
    } else {
      const base64Input = await base64_encode(JSON.stringify(postData));
      response = await postApi
        .getClient()
        .post(
          "index.php?c=vehicle&a=usagegraphreport",
          "postData=" + base64Input
        );
    }

    var usageGraphData = response?.data?.data?.usagedata;

    if (usageGraphData && usageGraphData) {
      usageGraphData.forEach((element) => {
        element.TotalTravelDistance = parseFloat(element.TotalTravelDistance);
      });
    }

    this.usageGraph = usageGraphData;
    return response?.data?.data?.usagedata;
  }
}

export default UsageGraphStore;
